import React from 'react';
import { Button, Stack } from '@mui/material';
import { VisibilityOff, Visibility } from '@mui/icons-material';

interface OpportunityFormActionsProps {
  status: string;
  canPublish: boolean;
  onPublish: () => void;
  onSave: (e: React.FormEvent) => void;
  onHide: () => void;
  onShow: () => void;
  reviewMessage?: string;
}

const OpportunityFormActions: React.FC<OpportunityFormActionsProps> = ({
  status,
  canPublish,
  onPublish,
  onSave,
  onHide,
  onShow,
}) => {
  const renderButtons = () => {
    switch (status) {
      case 'DRAFT':
        return (
          <>
            <Button variant="contained" size="large" onClick={onPublish} disabled={!canPublish}>
              Publicar
            </Button>
            <Button variant="outlined" size="large" onClick={onSave}>
              Guardar como borrador
            </Button>
          </>
        );

      case 'HIDDEN':
        return (
          <>
            <Button variant="contained" size="large" onClick={onShow} startIcon={<Visibility />}>
              Publicar nuevamente
            </Button>
            <Button variant="outlined" size="large" onClick={onSave}>
              Guardar cambios
            </Button>
          </>
        );

      case 'PENDING':
        return (
          <>
            <Button variant="contained" size="large" onClick={onSave}>
              Guardar cambios
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={onHide}
              startIcon={<VisibilityOff />}
              sx={{
                color: 'error.main',
                borderColor: 'error.main',
                '&:hover': {
                  backgroundColor: 'error.light',
                  borderColor: 'error.main',
                },
              }}
            >
              Ocultar del marketplace
            </Button>
          </>
        );

      case 'IN_REVIEW':
        return (
          <Button variant="contained" size="large" onClick={onSave}>
            Guardar cambios
          </Button>
        );
      case 'NEEDS_ATTENTION':
        return (
          <>
            <Button variant="contained" size="large" onClick={onSave}>
              Guardar y enviar a revisión
            </Button>
          </>
        );

      default:
        return (
          <Button variant="contained" size="large" onClick={onSave}>
            Guardar cambios
          </Button>
        );
    }
  };

  return (
    <Stack direction="row" spacing={2}>
      {renderButtons()}
    </Stack>
  );
};

export default OpportunityFormActions;
